import type { OAuthResult } from './auth.types';

let latestOAuthResult: OAuthResult | undefined;

function setLatestOAuthResult(authResult: OAuthResult): void {
  latestOAuthResult = authResult;
}

function getLatestOAuthResult(): OAuthResult | undefined {
  return latestOAuthResult;
}

function deleteLatestOAuthResult(): void {
  latestOAuthResult = undefined;
}

/**
 * Singleton used to store the latest OAuth result so that it can be passed through the OAuth flow redirects.
 */
const oAuthResultStorage = {
  setLatestOAuthResult,
  getLatestOAuthResult,
  deleteLatestOAuthResult,
};

export { oAuthResultStorage };
